import { createUseStyles } from 'react-jss'

import { container } from '../styles/common'
import { smallDesktopDown, smallDesktopUp } from '../styles/const/breakpoints'
import { sideMenuWidth } from '../features/components/Header/AuthorizedHeader/style'

const useStyles = createUseStyles({
  main: {}, // placeholder for class generation
  container: {
    extend: container
  },
  headingContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    columnGap: 32
  },
  leftHeadingColumn: {
    flexGrow: 1
  },
  breadCrumbs: {
    marginBottom: 28
  },
  partnershipShortInfo: {
    marginTop: 28,
    maxWidth: 400
  },
  [`@media screen and (${smallDesktopUp})`]: {
    // due to dynamic styles generation the rule is set lower than the mobile version,
    // so it has higher priority. to avoid bugs on mobile this rule generates in media as well
    main: {
      padding: ({ hasSideBar }) => `50px 50px 50px ${hasSideBar ? sideMenuWidth + 50 : 50}px`
    }
  },
  [`@media screen and (${smallDesktopDown})`]: {
    main: {
      padding: `24px`
    }
  }
})

export default useStyles
